/* eslint-disable-next-line no-restricted-imports */
import { Modal as AntDModal, ModalProps as AntDModalProps } from 'antd';
import styled from 'styled-components';
import { FC } from 'react';

export interface ModalProps extends AntDModalProps {
  maxWidth?: string | number;
  minWidth?: string | number;
}

const ModalComponent: FC<ModalProps> = (props) => {
  const {
    open = true,
    width = 'auto',
    maxWidth = 'calc(100vw - 2rem)',
    minWidth,
    styles,
    centered = true,
    ...rest
  } = props;

  return (
    <StyledModal
      {...rest}
      open={open}
      centered={centered}
      styles={{
        ...styles,
        content: {
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          maxHeight: 'calc(100vh - 2rem)',
          ...styles?.content,
        },
        body: {
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          flex: 1,
          minHeight: 0,
          ...styles?.body,
        },
      }}
      width={width}
      $maxWidth={maxWidth}
      $minWidth={minWidth}
    />
  );
};

const {
  info,
  success,
  error,
  warn,
  warning,
  confirm,
  useModal,
  destroyAll,
  config,
} = AntDModal;

export const Modal = Object.assign(ModalComponent, {
  info,
  success,
  error,
  warn,
  warning,
  confirm,
  useModal,
  destroyAll,
  config,
});

const StyledModal = styled(AntDModal)<{
  $maxWidth?: number | string;
  $minWidth?: number | string;
}>`
  ${({ $maxWidth }) =>
    typeof $maxWidth === 'undefined'
      ? ''
      : typeof $maxWidth === 'number'
        ? `max-width: ${$maxWidth}px;`
        : `max-width: ${$maxWidth};`}
  ${({ $minWidth }) =>
    typeof $minWidth === 'undefined'
      ? ''
      : typeof $minWidth === 'number'
        ? `min-width: ${$minWidth}px;`
        : `min-width: ${$minWidth};`}

  margin: 0;

  .ant-modal-content {
    padding: 0;
  }
  .ant-modal-footer {
    margin: 0;
  }
`;
